import { images } from '.';

const testimonials = [ 
    { 
        id: 1,
        image: images.team2,
        name: 'Kephern Murphy',
        title: 'Owner',
        content: 'BrewCraft Café has completely changed my mornings. Their coffee is rich, smooth, and consistently fresh. The staff is always welcoming, making it the perfect start to my day.',
    },
    /*{
        id: 2,
        image: images.testimonial2,
        name: 'Evelyn Jones',
        title: 'Manager',
        content: 'This café is a gem! The cozy atmosphere, delicious pastries, and expertly brewed lattes keep me coming back. Highly recommend for coffee lovers and remote workers alike.',
    },
    { 
        id: 3,
        image: images.testimonial3,
        name: 'Viraj Patel',
        title: 'Client',
        content: 'Best cappuccino in town. The baristas really know their craft, and the attention to detail in every drink is impressive. It’s my go-to spot for both meetings and me-time.',
    },*/
    { 
        id: 2,
        image: images.team4,
        name: 'Kameron Murphy',
        title: 'Marketing Specialist',
        content: 'A delightful experience every time! The staff is friendly, the environment is relaxing, and the seasonal specials are always a treat. Love everything about this place.',
    },
];

export default testimonials;